import React, { useState, useEffect, useRef, useMemo } from "react";
import "./styles/filtersProperty.css";
import { IoIosArrowDown, IoMdClose } from "react-icons/io";
import { getApprovedLocations } from "../../services/api/properties";

export default function FiltersProperty({ onFilterChange }) {
  const [selectedCity, setSelectedCity] = useState("Praia Grande");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedSubOption, setSelectedSubOption] = useState("");
  const [selectedYearOption, setSelectedYearOption] = useState("");
  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [dorms, setDorms] = useState([]);
  const [suites, setSuites] = useState([]);
  const [banheiros, setBanheiros] = useState([]);
  const [vagas, setVagas] = useState([]);
  const [comissoes, setComissoes] = useState([]);
  const [selectedBairros, setSelectedBairros] = useState([]);

  // Snapshot do que foi de fato aplicado (via "Aplicar"/"Limpar"), usado só para a label "Filtros ativos".
  // Mantido separado dos estados acima porque estes mudam a cada clique no checkbox, antes de aplicar.
  const [appliedFilters, setAppliedFilters] = useState({
    selectedCity: "Praia Grande",
    selectedCategory: "",
    selectedBairros: [],
    selectedOption: "",
    selectedSubOption: "",
    selectedYearOption: "",
    minValue: "",
    maxValue: "",
    dorms: [],
    banheiros: [],
    suites: [],
    vagas: [],
    comissoes: [],
    checkboxFilters: {
      apartamentos: false,
      casas: false,
      casasCondominio: false,
      galpao: false,
      terreno: false,
      salaComercial: false,
      pontoComercial: false,
      financiamentoDireto: false,
      permuta: false,
      lazerCompleto: false,
      piscina: false,
      mobiliado: false,
      edicula: false,
      frenteAoMar: false,
      vistaAoMar: false,
      proximoPraia: false,
      zona_1_2: false,
      zona3: false,
    },
  });

  const [openArticles, setOpenArticles] = useState({});
  const articleRefs = useRef({});
  const toggleButtonRefs = useRef({});
  const [isOverlayVisible, setOverlayVisible] = useState(false);

  const [locationsData, setLocationsData] = useState({
    cities: [],
    structure: {},
  });

  const ORDEM_BAIRROS_PG = [
    "Forte", "Boqueirão", "Guilhermina", "Aviação", "Tupi", "Ocian", "Mirim",
    "Maracanã", "Caiçara", "Vilamar", "Jardim Real", "Imperador", "Flórida",
    "Solemar", "Sítio do Campo", "Tude Bastos", "Jardim Glória", "Vila Sonia",
    "Vila Antártica", "Balneário Maxland", "Tupiry", "Anhanguera", "Quietude",
    "Nova Mirim", "Ribeirópolis", "Jardim Trevo", "Balneário Esmeralda",
    "Samambaia", "Parque das Américas", "Jardim Melvi", "Jardim Princesa",
    "Cidade das Crianças",
  ];

  const [checkboxFilters, setCheckboxFilters] = useState({
    apartamentos: false,
    casas: false,
    casasCondominio: false,
    galpao: false,
    terreno: false,
    salaComercial: false,
    pontoComercial: false,
    financiamentoDireto: false,
    permuta: false,
    lazerCompleto: false,
    piscina: false,
    mobiliado: false,
    edicula: false,
    frenteAoMar: false,
    vistaAoMar: false,
    proximoPraia: false,
    zona_1_2: false,
    zona3: false,
  });

  const checkboxLabels = {
    apartamentos: "Apartamentos",
    casas: "Casas isoladas/geminadas",
    casasCondominio: "Casas em Condomínio",
    galpao: "Galpão",
    terreno: "Terreno",
    salaComercial: "Sala Comercial",
    pontoComercial: "Ponto Comercial",
    financiamentoDireto: "Financiamento Direto",
    permuta: "Permuta",
    lazerCompleto: "Lazer Completo",
    piscina: "Piscina",
    mobiliado: "Mobiliado",
    edicula: "Com Edícula",
    frenteAoMar: "Frente ao Mar",
    vistaAoMar: "Vista ao Mar",
    proximoPraia: "Próximo a Praia",
    zona_1_2: "Zona 1 / Zona 2",
    zona3: "Zona 3",
  };

  useEffect(() => {
    async function fetchLocations() {
      try {
        const data = await getApprovedLocations();

        let sortedCities = (data.cities || []).sort();

        const pgIndex = sortedCities.indexOf("Praia Grande");
        if (pgIndex > -1) {
          sortedCities.splice(pgIndex, 1);
          sortedCities.unshift("Praia Grande");
        }

        setLocationsData({ ...data, cities: sortedCities });
      } catch (error) {
        console.error("Erro ao carregar opções de filtro:", error);
      }
    }
    fetchLocations();
  }, []);

  const bairrosDisponiveis = useMemo(() => {
    if (!selectedCity) return [];

    if (selectedCity === "Praia Grande") {
      const listaFinal = [...ORDEM_BAIRROS_PG];
      const bairrosDoBanco = locationsData.structure[selectedCity] || [];
      
      bairrosDoBanco.forEach((bairro) => {
        if (!listaFinal.includes(bairro)) {
          listaFinal.push(bairro);
        }
      });

      return listaFinal;
    }

    const list = [...(locationsData.structure[selectedCity] || [])];
    return list.sort(); 
  }, [selectedCity, locationsData]);

  const handleApplyFilters = () => {
    let normalizedComissoes = [];
    if (comissoes.length > 0) {
      if (comissoes.includes("4")) {
        normalizedComissoes.push("4.0", "4", "0.04");
      }
      if (comissoes.includes("5")) {
        normalizedComissoes.push("5.0", "5", "0.05");
      }
      if (comissoes.includes("6")) {
        normalizedComissoes.push("6.0", "6", "0.06");
      }
      if (comissoes.includes("999")) {
        normalizedComissoes.push("999.0", "0");
      }
    }

    const filtersToSend = {
      city: selectedCity,
      category: selectedCategory,
      option: selectedOption,
      subOption: selectedSubOption,
      year: selectedYearOption,
      min_price: minValue,
      max_price: maxValue,
      dorms: dorms,
      banheiros: banheiros,
      suites: suites,
      vagas: vagas,
      comissoes: normalizedComissoes,
      bairros: selectedBairros,
      ...Object.keys(checkboxFilters).reduce((acc, key) => {
        if (checkboxFilters[key]) acc[key] = "true";
        return acc;
      }, {}),
    };

    onFilterChange(filtersToSend);
    setAppliedFilters({
      selectedCity,
      selectedCategory,
      selectedBairros,
      selectedOption,
      selectedSubOption,
      selectedYearOption,
      minValue,
      maxValue,
      dorms,
      banheiros,
      suites,
      vagas,
      comissoes,
      checkboxFilters,
    });
    closeAllArticles();
  };

  const resetValores = () => {
    setMinValue("");
    setMaxValue("");
    setCheckboxFilters((prev) => ({
      ...prev,
      financiamentoDireto: false,
      permuta: false,
    }));
  };

  const resetBairros = () => {
    setSelectedBairros([]);
    setSelectedCity("Praia Grande");
  };

  const resetComissao = () => {
    setComissoes([]);
  };

  const resetComodos = () => {
    setDorms([]);
    setSuites([]);
    setBanheiros([]);
    setVagas([]);
  };

  const resetTipoImovel = () => {
    setCheckboxFilters((prev) => ({
      ...prev,
      apartamentos: false,
      casas: false,
      casasCondominio: false,
      galpao: false,
      terreno: false,
      salaComercial: false,
      pontoComercial: false,
    }));
  };

  const resetCaracteristicas = () => {
    setCheckboxFilters((prev) => ({
      ...prev,
      lazerCompleto: false,
      piscina: false,
      mobiliado: false,
      edicula: false,
      frenteAoMar: false,
      vistaAoMar: false,
      proximoPraia: false,
    }));
  };

  const resetZonas = () => {
    setCheckboxFilters((prev) => ({
      ...prev,
      zona_1_2: false,
      zona3: false,
    }));
  };

  const resetResponsavel = () => {
    setSelectedCategory("");
    setSelectedOption("");
    setSelectedSubOption("");
    setSelectedYearOption("");
  };

  const handleClickOutside = (event) => {
    if (!articleRefs.current) return;
    for (const [key, ref] of Object.entries(articleRefs.current || {})) {
      const isOutsideArticle = ref && !ref.contains(event.target);
      const isNotToggleButton = event.target !== toggleButtonRefs.current[key];
      if (isOutsideArticle && isNotToggleButton) {
        setOpenArticles((prev) => ({ ...(prev || {}), [key]: false }));
      }
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") closeAllArticles();
    };
    if (isOverlayVisible) window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOverlayVisible]);

  const toggleArticle = (key) => {
    setOpenArticles((prev) => {
      const newState = {};
      Object.keys(prev).forEach((k) => (newState[k] = false));
      newState[key] = !prev[key];
      setOverlayVisible(newState[key]);
      return newState;
    });
  };

  const closeAllArticles = () => {
    setOpenArticles({});
    setOverlayVisible(false);
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedOption("");
    setSelectedSubOption("");
    setSelectedYearOption("");
  };

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setSelectedSubOption("");
    setSelectedYearOption("");
  };

  const handleSubOptionChange = (e) => {
    setSelectedSubOption(e.target.value);
    setSelectedYearOption("");
  };

  const handleYearOptionChange = (e) => setSelectedYearOption(e.target.value);

  const handleCheckboxChange = (e) => {
    setCheckboxFilters({
      ...checkboxFilters,
      [e.target.name]: e.target.checked,
    });
  };

  const handleComissoesChange = (e) => {
    const { value, checked } = e.target;
    setComissoes((prev) =>
      checked ? [...prev, value] : prev.filter((c) => c !== value),
    );
  };

  const handleArrayToggle = (setter) => (e) => {
    const { value, checked } = e.target;
    setter((prev) =>
      checked ? [...prev, value] : prev.filter((v) => v !== value),
    );
  };

  const handleBairroChange = (e) => {
    const { value, checked } = e.target;
    setSelectedBairros((prev) =>
      checked ? [...prev, value] : prev.filter((b) => b !== value),
    );
  };

  const clearFilters = () => {
    setSelectedCity("Praia Grande");
    setSelectedCategory("");
    setSelectedOption("");
    setSelectedSubOption("");
    setSelectedYearOption("");
    setMinValue("");
    setMaxValue("");
    setDorms([]);
    setSuites([]);
    setBanheiros([]);
    setVagas([]);
    setComissoes([]);
    setSelectedBairros([]);
    const resetCheckboxes = {
      apartamentos: false,
      casas: false,
      casasCondominio: false,
      galpao: false,
      terreno: false,
      salaComercial: false,
      pontoComercial: false,
      financiamentoDireto: false,
      permuta: false,
      lazerCompleto: false,
      piscina: false,
      mobiliado: false,
      edicula: false,
      frenteAoMar: false,
      vistaAoMar: false,
      proximoPraia: false,
      zona_1_2: false,
      zona3: false,
    };
    setCheckboxFilters(resetCheckboxes);
    onFilterChange({
      city: "Praia Grande",
      category: "",
      option: "",
      subOption: "",
      year: "",
      min_price: "",
      max_price: "",
      dorms: [],
      banheiros: [],
      suites: [],
      vagas: [],
      comissoes: [],
      bairros: [],
    });
    setAppliedFilters({
      selectedCity: "Praia Grande",
      selectedCategory: "",
      selectedBairros: [],
      selectedOption: "",
      selectedSubOption: "",
      selectedYearOption: "",
      minValue: "",
      maxValue: "",
      dorms: [],
      banheiros: [],
      suites: [],
      vagas: [],
      comissoes: [],
      checkboxFilters: resetCheckboxes,
    });
  };

  const handleInputChange = (e, isMin) => {
    let inputValue = e.target.value
      .replace(/[^\d]/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    isMin ? setMinValue(inputValue) : setMaxValue(inputValue);
  };

  const getAppliedFiltersText = () => {
    const {
      selectedCity: appliedCity,
      selectedCategory: appliedCategory,
      selectedBairros: appliedBairros,
      selectedOption: appliedOption,
      selectedSubOption: appliedSubOption,
      selectedYearOption: appliedYearOption,
      minValue: appliedMinValue,
      maxValue: appliedMaxValue,
      dorms: appliedDorms,
      banheiros: appliedBanheiros,
      suites: appliedSuites,
      vagas: appliedVagas,
      comissoes: appliedComissoes,
      checkboxFilters: appliedCheckboxFilters,
    } = appliedFilters;

    const activeFilters = [];
    if (appliedCity && appliedCity !== "Praia Grande") {
      activeFilters.push(`Cidade: ${appliedCity}`);
    }
    if (appliedCategory) activeFilters.push(`Tipo: ${appliedCategory}`);
    if (appliedBairros.length > 0)
      activeFilters.push(`Bairros: ${appliedBairros.join(", ")}`);
    if (appliedOption) activeFilters.push(`Opção: ${appliedOption}`);
    if (appliedSubOption) activeFilters.push(`Subopção: ${appliedSubOption}`);
    if (appliedYearOption) activeFilters.push(`Ano: ${appliedYearOption}`);
    if (appliedMinValue) activeFilters.push(`Valor mínimo: R$ ${appliedMinValue}`);
    if (appliedMaxValue) activeFilters.push(`Valor máximo: R$ ${appliedMaxValue}`);
    if (appliedDorms.length > 0)
      activeFilters.push(`Dormitórios: ${appliedDorms.join(", ")}`);
    if (appliedBanheiros.length > 0)
      activeFilters.push(`Banheiros: ${appliedBanheiros.join(", ")}`);
    if (appliedSuites.length > 0) activeFilters.push(`Suítes: ${appliedSuites.join(", ")}`);
    if (appliedVagas.length > 0) activeFilters.push(`Vagas: ${appliedVagas.join(", ")}`);
    if (appliedComissoes.length > 0) {
      const comissaoLabels = appliedComissoes
        .map((c) => (c === "999" ? "Fifty" : `${c}%`))
        .join(", ");
      activeFilters.push(`Comissão: ${comissaoLabels}`);
    }
    const checkboxes = Object.entries(appliedCheckboxFilters)
      .filter(([_, checked]) => checked)
      .map(([key]) => checkboxLabels[key]);
    if (checkboxes.length > 0)
      activeFilters.push(`Características: ${checkboxes.join(", ")}`);

    if (activeFilters.length === 0) return null;

    return (
      <>
        <strong>Filtros ativos: </strong>
        {activeFilters.map((filterString, index) => {
          const parts = filterString.split(/:(.*)/s);
          return (
            <span key={index}>
              <strong>{parts[0]}:</strong>
              {parts[1]}
              {index < activeFilters.length - 1 && " | "}
            </span>
          );
        })}
      </>
    );
  };

  const comissaoOptions = [
    { value: "4", label: "4%" },
    { value: "5", label: "5%" },
    { value: "6", label: "6%" },
    { value: "999", label: "Fifty" },
  ];

  return (
    <div style={{ width: "100%" }}>
      {isOverlayVisible && (
        <div className="overlay" onClick={closeAllArticles}></div>
      )}
      <section className="container-filters">
        <article className="filters">
          <button
            className={`bt-filter ${minValue || maxValue || checkboxFilters.financiamentoDireto || checkboxFilters.permuta ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["valores"] = el)}
            onClick={() => toggleArticle("valores")}
          >
            VALORES
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["valores"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["valores"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>VALORES DOS IMÓVEIS</h2>
              <section className="field-filters">
                <label htmlFor="minValue">Mínimos:</label>
                <input
                  type="text"
                  id="minValue"
                  value={minValue}
                  onChange={(e) => handleInputChange(e, true)}
                  placeholder="R$ 0,00"
                />
              </section>
              <section className="field-filters">
                <label htmlFor="maxValue">Máximos:</label>
                <input
                  type="text"
                  id="maxValue"
                  value={maxValue}
                  onChange={(e) => handleInputChange(e, false)}
                  placeholder="R$ 0,00"
                />
              </section>
              <h3>MEIOS DE PAGAMENTO</h3>
              <section className="field-filters-checkboxes">
                <input
                  id="financiamento-direto"
                  type="checkbox"
                  name="financiamentoDireto"
                  checked={checkboxFilters.financiamentoDireto}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="financiamento-direto">
                  {checkboxLabels.financiamentoDireto}
                </label>
              </section>
              <section className="field-filters-checkboxes">
                <input
                  id="permuta"
                  type="checkbox"
                  name="permuta"
                  checked={checkboxFilters.permuta}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="permuta">{checkboxLabels.permuta}</label>
              </section>
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetValores}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${selectedBairros.length > 0 || (selectedCity && selectedCity !== "Praia Grande") ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["bairro"] = el)}
            onClick={() => toggleArticle("bairro")}
          >
            BAIRROS/CIDADES
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["bairro"] && (
            <div
              className="filters-box-suspense bairro-layout"
              ref={(el) => (articleRefs.current["bairro"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <div className="bairro-header">
                <h2>BAIRROS</h2>
                <p>
                  {selectedCity
                    ? `Exibindo bairros de: ${selectedCity}`
                    : "Selecione uma cidade"}
                </p>
              </div>

              <div className="bairro-body">
                <div className="checkbox-grid-refined">
                  {bairrosDisponiveis.length > 0 ? (
                    bairrosDisponiveis.map((bairro) => (
                      <div
                        key={bairro}
                        className="checkbox-item"
                        onClick={(e) => {
                          e.preventDefault();
                          const isSelected = selectedBairros.includes(bairro);
                          handleBairroChange({
                            target: { value: bairro, checked: !isSelected },
                          });
                        }}
                      >
                        <input
                          type="checkbox"
                          id={`bairro-${bairro}`}
                          value={bairro}
                          checked={selectedBairros.includes(bairro)}
                          readOnly
                        />
                        <label htmlFor={`bairro-${bairro}`}>{bairro}</label>
                      </div>
                    ))
                  ) : (
                    <p style={{ padding: "10px", color: "#333" }}>
                      Nenhum bairro encontrado ou carregando...
                    </p>
                  )}
                </div>
              </div>

              <div className="bairro-footer">
                <span className="footer-title">Filtrar lista por cidade:</span>
                <div className="pills-container">
                  {locationsData.cities.map((city) => (
                    <button
                      key={city}
                      className={`city-pill ${selectedCity === city ? "active" : ""}`}
                      onClick={() => {
                        setSelectedCity(city);
                        setSelectedBairros([]);
                      }}
                    >
                      {city}
                    </button>
                  ))}
                </div>
                <div className="modal-actions">
                  <button type="button" className="btn-modal-reset" onClick={resetBairros}>Resetar</button>
                  <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
                </div>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${comissoes.length > 0 ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["comissao"] = el)}
            onClick={() => toggleArticle("comissao")}
          >
            COMISSÃO
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["comissao"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["comissao"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>COMISSÃO</h2>
              {comissaoOptions.map((option) => (
                <section
                  className="field-filters-checkboxes"
                  key={option.value}
                >
                  <input
                    id={`comissao-${option.value}`}
                    type="checkbox"
                    name="comissao"
                    value={option.value}
                    checked={comissoes.includes(option.value)}
                    onChange={handleComissoesChange}
                  />
                  <label htmlFor={`comissao-${option.value}`}>
                    {option.label}
                  </label>
                </section>
              ))}
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetComissao}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${dorms.length > 0 || banheiros.length > 0 || suites.length > 0 || vagas.length > 0 ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["comodos"] = el)}
            onClick={() => toggleArticle("comodos")}
          >
            CÔMODOS
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["comodos"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["comodos"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>QUANTIDADE DE CÔMODOS</h2>
              <section className="field-filters">
                <label>Dormitórios:</label>
                <div className="group-checkboxes">
                  {["1", "2", "3", "4", "5"].map((value) => (
                    <label htmlFor={`number-dorms${value}`} key={value}>
                      <input
                        type="checkbox"
                        id={`number-dorms${value}`}
                        value={value}
                        onChange={handleArrayToggle(setDorms)}
                        checked={dorms.includes(value)}
                      />
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
              </section>
              <section className="field-filters">
                <label>Banheiros:</label>
                <div className="group-checkboxes">
                  {["1", "2", "3", "4", "5"].map((value) => (
                    <label htmlFor={`number-banheiros${value}`} key={value}>
                      <input
                        type="checkbox"
                        id={`number-banheiros${value}`}
                        value={value}
                        onChange={handleArrayToggle(setBanheiros)}
                        checked={banheiros.includes(value)}
                      />
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
              </section>
              <section className="field-filters">
                <label>Suítes:</label>
                <div className="group-checkboxes">
                  {["1", "2", "3", "4", "5"].map((value) => (
                    <label htmlFor={`number-suites${value}`} key={value}>
                      <input
                        type="checkbox"
                        id={`number-suites${value}`}
                        value={value}
                        onChange={handleArrayToggle(setSuites)}
                        checked={suites.includes(value)}
                      />
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
              </section>
              <section className="field-filters">
                <label>Vagas:</label>
                <div className="group-checkboxes">
                  {["1", "2", "3", "4", "5"].map((value) => (
                    <label htmlFor={`number-vagas${value}`} key={value}>
                      <input
                        type="checkbox"
                        id={`number-vagas${value}`}
                        value={value}
                        onChange={handleArrayToggle(setVagas)}
                        checked={vagas.includes(value)}
                      />
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
              </section>
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetComodos}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${checkboxFilters.apartamentos || checkboxFilters.casas || checkboxFilters.casasCondominio || checkboxFilters.galpao || checkboxFilters.terreno || checkboxFilters.salaComercial || checkboxFilters.pontoComercial ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["tipo-imovel"] = el)}
            onClick={() => toggleArticle("tipo-imovel")}
          >
            TIPO DE IMÓVEL
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["tipo-imovel"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["tipo-imovel"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>TIPO DE IMÓVEL</h2>
              {Object.entries(checkboxLabels)
                .filter(([key]) =>
                  [
                    "apartamentos",
                    "casas",
                    "casasCondominio",
                    "galpao",
                    "terreno",
                    "salaComercial",
                    "pontoComercial",
                  ].includes(key),
                )
                .map(([key, label]) => (
                  <section className="field-filters-checkboxes" key={key}>
                    <input
                      id={key}
                      type="checkbox"
                      name={key}
                      checked={checkboxFilters[key]}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={key}>{label}</label>
                  </section>
                ))}
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetTipoImovel}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${checkboxFilters.lazerCompleto || checkboxFilters.piscina || checkboxFilters.mobiliado || checkboxFilters.edicula || checkboxFilters.frenteAoMar || checkboxFilters.vistaAoMar || checkboxFilters.proximoPraia ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["caracteristicas"] = el)}
            onClick={() => toggleArticle("caracteristicas")}
          >
            CARACTERÍSTICAS
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["caracteristicas"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["caracteristicas"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>CARACTERÍSTICAS</h2>
              {Object.keys(checkboxFilters)
                .filter(
                  (key) =>
                    ![
                      "apartamentos",
                      "casas",
                      "casasCondominio",
                      "galpao",
                      "terreno",
                      "salaComercial",
                      "pontoComercial",
                      "financiamentoDireto",
                      "permuta",
                      "zona_1_2",
                      "zona3",
                    ].includes(key),
                )
                .map((key) => (
                  <div className="field-filters-checkboxes" key={key}>
                    <input
                      id={`checkbox-${key}`}
                      type="checkbox"
                      name={key}
                      checked={checkboxFilters[key]}
                      onChange={handleCheckboxChange}
                    />
                    <label htmlFor={`checkbox-${key}`}>
                      {checkboxLabels[key] || key}
                    </label>
                  </div>
                ))}
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetCaracteristicas}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${checkboxFilters.zona_1_2 || checkboxFilters.zona3 ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["zonas"] = el)}
            onClick={() => toggleArticle("zonas")}
          >
            ZONAS
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["zonas"] && (
            <div
              className="filters-box-suspense"
              ref={(el) => (articleRefs.current["zonas"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>ZONAS</h2>
              <section className="field-filters-checkboxes">
                <input
                  id="zona_1_2"
                  type="checkbox"
                  name="zona_1_2"
                  checked={checkboxFilters.zona_1_2}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="zona_1_2">{checkboxLabels.zona_1_2}</label>
              </section>
              <section className="field-filters-checkboxes">
                <input
                  id="zona3"
                  type="checkbox"
                  name="zona3"
                  checked={checkboxFilters.zona3}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="zona3">{checkboxLabels.zona3}</label>
              </section>
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetZonas}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>

        <article className="filters">
          <button
            className={`bt-filter ${selectedCategory || selectedOption || selectedSubOption || selectedYearOption ? "active" : ""}`}
            ref={(el) => (toggleButtonRefs.current["responsavel"] = el)}
            onClick={() => toggleArticle("responsavel")}
          >
            RESPONSÁVEL
            <i>
              <IoIosArrowDown />
            </i>
          </button>
          {openArticles["responsavel"] && (
            <div
              className="filters-box-suspense wrap"
              ref={(el) => (articleRefs.current["responsavel"] = el)}
            >
              <button className="close-modal-btn" onClick={closeAllArticles}>
                <IoMdClose />
              </button>
              <h2>TIPO</h2>
              <section className="field-filters">
                <label>Tipo de Anunciante:</label>
                <select
                  value={selectedCategory}
                  onChange={handleCategoryChange}
                  className="select-filter"
                >
                  <option value=""></option>
                  <option value="Construtora">CONSTRUTORA</option>
                  <option value="Investidor">INVESTIDOR</option>
                  <option value="Imobiliária">IMOBILIÁRIA</option>
                </select>
              </section>

              {(selectedCategory === "Construtora" ||
                selectedCategory === "Investidor" ||
                selectedCategory === "Imobiliária") && (
                <section className="field-filters">
                  <label>Opção Avançada:</label>
                  <select
                    value={selectedOption}
                    onChange={handleOptionChange}
                    className="select-filter"
                  >
                    <option value=""></option>
                    <option value="Lançamento">LANÇAMENTOS</option>

                    {/* ALTERAÇÃO: Somente construtora vê Revenda */}
                    {selectedCategory === "Construtora" && (
                      <option value="Revenda">REVENDAS</option>
                    )}

                    <option value="Casa em Condomínio">
                      CASAS EM CONDOMÍNIOS
                    </option>
                  </select>
                </section>
              )}

              {(selectedOption === "Lançamento" ||
                selectedOption === "Casa em Condomínio") && (
                <section className="field-filters">
                  <label>Subopção Avançada:</label>
                  <select
                    value={selectedSubOption}
                    onChange={handleSubOptionChange}
                    className="select-filter"
                  >
                    <option value=""></option>
                    <option value="Entregue">ENTREGUES</option>
                    <option value="Em construção">EM CONSTRUÇÃO</option>
                  </select>
                </section>
              )}

              {selectedSubOption === "Em construção" && (
                <section className="field-filters">
                  <label>Ano de Entrega:</label>
                  <select
                    value={selectedYearOption}
                    onChange={handleYearOptionChange}
                    className="select-filter"
                  >
                    <option value=""></option>
                    {Array.from(
                      { length: 8 },
                      (_, i) => new Date().getFullYear() + i,
                    ).map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </section>
              )}
              <div className="modal-actions">
                <button type="button" className="btn-modal-reset" onClick={resetResponsavel}>Resetar</button>
                <button type="button" className="btn-modal-apply" onClick={handleApplyFilters}>Aplicar</button>
              </div>
            </div>
          )}
        </article>
      </section>

      <section className="bts-filters">
        {getAppliedFiltersText() && (
          <div className="applied-filters">
            <p>{getAppliedFiltersText()}</p>
          </div>
        )}
        {(appliedFilters.minValue ||
          appliedFilters.maxValue ||
          Object.values(appliedFilters.checkboxFilters).includes(true) ||
          appliedFilters.dorms.length > 0 ||
          appliedFilters.banheiros.length > 0 ||
          appliedFilters.suites.length > 0 ||
          appliedFilters.vagas.length > 0 ||
          appliedFilters.comissoes.length > 0 ||
          appliedFilters.selectedBairros.length > 0 ||
          appliedFilters.selectedCategory ||
          appliedFilters.selectedOption ||
          appliedFilters.selectedSubOption ||
          appliedFilters.selectedYearOption ||
          (appliedFilters.selectedCity &&
            appliedFilters.selectedCity !== "Praia Grande")) && (
          <button className="bt-clear-filters" onClick={clearFilters}>
            LIMPAR FILTROS
          </button>
        )}
      </section>
    </div>
  );
}